import { Button, Heading5 } from '@casavo/base-ui'

import { ModalContextType } from '@/context/ModalContext'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { handleListingDetailGalleryModalClick } from '@/utils/tracking/eventsHandlers'

import Close from '../Icon/Close'

import { modalHeaderTitleButtonWrapper } from './style.css'
import { pointShapeDivider } from './Types/SaveSearch/Content/styles.css'

const ModalHeaderTitle: React.FC<{
  cityName: string
  closeModal: ModalContextType['closeModal']
  title: string
}> = ({ cityName, closeModal, title }) => {
  return (
    <div className={sprinkles({ alignItems: 'center', display: 'flex', marginBottom: 'm' })}>
      <Heading5 className={sprinkles({ textTransform: 'uppercase' })}>{cityName}</Heading5>
      <div className={pointShapeDivider} />
      <Heading5>{title}</Heading5>{' '}
      <span className={modalHeaderTitleButtonWrapper}>
        <Button
          ariaLabel="Close"
          Icon={(props) => <Close {...props} />}
          shapeVariant="round"
          styleVariant="tertiary"
          onClick={() => {
            closeModal()
            handleListingDetailGalleryModalClick('Close')
          }}
        />
      </span>
    </div>
  )
}

export default ModalHeaderTitle
